import { useState } from "react";
import type { EntityTypeDefinition } from "../../../lib/types";
import { useArchiveEntity } from "../../../lib/hooks/use-kuvio";
import { ActionMenu } from "../shell/ActionMenu";
import { ConfirmModal } from "../primitives";

interface RowActionMenuProps {
  rowId: string;
  rowTitle?: string;
  entityType: EntityTypeDefinition;
}

export function RowActionMenu({ rowId, rowTitle, entityType }: RowActionMenuProps) {
  const [confirmOpen, setConfirmOpen] = useState(false);
  const archiveEntity = useArchiveEntity(entityType);

  const displayName = rowTitle || rowId.slice(0, 8);

  return (
    <>
      <ActionMenu
        items={[
          {
            label: "Archive row",
            icon: "archive",
            variant: "danger",
            onClick: () => setConfirmOpen(true),
          },
        ]}
      />
      <ConfirmModal
        open={confirmOpen}
        onOpenChange={setConfirmOpen}
        title={`Archive '${displayName}'?`}
        message="This row will be hidden from views. Archived items are recoverable via MCP until purged."
        confirmLabel="Archive row"
        variant="danger"
        onConfirm={async () => {
          await archiveEntity.mutateAsync({ id: rowId });
          setConfirmOpen(false);
        }}
      />
    </>
  );
}
